'use strict';

const assertNative = require('./assertNative');

/**
 * Returns true if the given object is a plain object (it was
 * not created by a different constructor then simply `{}`)
 *
 * @param  {*}  obj
 * @return {Boolean}     [description]
 */
module.exports = function isPlainObject (obj) {
  assertNative(obj);
  return (obj !== null
    && typeof obj === 'object'
    && obj.constructor === Object);
};



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/isPlainObject.js